/*
  * HTML5GameService Service
  * @desc This calls has standard functionality needed by all games
  * @author Jeff Keene Jeff.Keene@thegameagency.com
  * @required amplify.js, phaser.js, EverFi SDK
 */
var EnrollmentDataService = require('services/enrollment-data-service');
var LocaleService = require('services/locale-service');

var HTML5GameService = {
  initPhaserGame: function(settings, callbacks){
    this.callbacks = callbacks;
    this.containerID = settings.gameId;
    this.menuBarOffset = settings.menuBarOffset;
    this.actionBarOffset = settings.actionBarOffset;
    this.width = settings.width;
    this.height = settings.height;
    var container = document.getElementById(settings.gameId);
    this.gameController = new Phaser.Game(settings.width, settings.height, Phaser.AUTO, container);
    this.gameController.HTML5GameService = this;

    var gameStates = require(settings.gameScriptsPath+'Boot');
    gameStates.Preloader = require(settings.gameScriptsPath+'Preloader');
    gameStates.Game = require(settings.gameScriptsPath+'Game');

    this.gameController.state.add('Boot', gameStates.Boot);
    this.gameController.state.add('Preloader', gameStates.Preloader);
    this.gameController.state.add('Game', gameStates.Game);
    this.startGame();
    return this.gameController;
  },
  startGame: function(){
    this.gameController.state.start('Boot');
  },

  endGame: function(){
    Chaplin.mediator.publish('simulationEnded');
    this.callbacks.end();
  },

  getString: function(key){
    var result = LocaleService.t(key);
    return new Handlebars.SafeString(result);
  },

  getObject: function(key){
    return LocaleService.t(key, {returnObjectTrees:true});
  },

  saveData: function(data_key, data){
    EnrollmentDataService.saveData(data_key, data);
  },

  getData: function(data_key){
    return EnrollmentDataService.getData(data_key);
  },

  getRootURLHelper: function(){
    return "";
  },

  centerCanvas: function () {
    var canvas = $('#'+this.containerID);
    var parent = canvas.parent();
    parent.css('position','absolute');
    canvas.css('position','absolute');
    window.addEventListener('load', $.proxy(this.repositionCanvas, this),false);
    window.addEventListener('resize',$.proxy(this.repositionCanvas, this),false);
    this.repositionCanvas();
  },

  repositionCanvas: function(){
    var canvas = $('#'+this.containerID);
    var ratio = window.innerWidth/(window.innerHeight-this.menuBarOffset-this.actionBarOffset);
    if(ratio <= 16/9){
      canvas.css('top', Math.round((window.innerHeight - canvas.height())/2)+'px');
      canvas.css('width',window.innerWidth+'px').css('height','auto');
      canvas.css('left',Math.round((window.innerWidth - canvas.width() )/2) + 'px');
    }else{
      canvas.css('top', this.menuBarOffset+'px');
      canvas.css('height',(window.innerHeight - (this.menuBarOffset+this.actionBarOffset))+'px').css('width','auto');
      canvas.css('left',((window.innerWidth - canvas.width() )/2) + 'px');
    }
  }
};

module.exports = HTML5GameService;